<div class="srIrops-itinerary" style="gap: 60px;">
  <div class="srIrops-newItinerary">
    <div class="srIrops-textNewItinerary text-am-white fs-24px fw-regular lh-30px mb-2">
      <span>
        {{ "srIrops.itineraryAfected" | translate }}
      </span>
    </div>
    <!-- <div class="srIrops-tagTimeChangeSmall text-am-white fs-20px lh-28px fw-medium-x">
      <span>
        {{ "flightStatus.on_time" | translate }}
      </span>
    </div> -->
  </div>
  <div class="srIrops-separatorLine" style="height: 100px;"></div>
  <div class="srIrops-routeOriginDestination">
    <div class="srIrops-origin">
      <span class="srIrops-originDate text-am-white fs-24px fw-regular lh-34px">
        {{ dateDeparture | localizedDate:'dd MMM' | lowercase }}
      </span>
      <div class="srIrops-originHour">
        <div class="text-am-white fs-32px fw-medium-x lh-42px"
          [ngClass]="{ 'srIrops-textNotAffected': !isAfectedFirstSeg }">
          <span>
            {{ timeItinerary.departureTime | validHourUndefined }}
          </span>
        </div>
      </div>
      <div class="srIrops-originDeparture text-am-white fs-24px fw-regular lh-34px">
        <span>
          {{ firstSegment?.departureAirport }}
        </span>
      </div>
    </div>
    <div class="srIrops-lineRoute">
      <div class="srIrops-pointOrigin"
        [ngClass]="{ 'srIrops-isNotAffected': !isAfectedFirstSeg }">
      </div>
      <div class="srIrops-lineOne" [ngClass]="{ 'srIrops-isNotAffected': !isAfectedFirstSeg }">
      </div>

      <div class="srIrops-pointConnecting" *ngIf="[3,4].includes(lineRoute)">
        {{ segments?.length - 1 }}
      </div>

      <div class="srIrops-textMedItinerary">
        <span class="text-am-white opacity-75 fs-18px lh-24px fw-regular">
          {{ 'flightInfo.Duration' | translate }} {{ duration.hours }}h {{ duration.minutes }}m
        </span>
      </div>

      <div class="srIrops-textOneConnecting" *ngIf="lineRoute == 3">
        <div class="fs-22px text-am-white">
          {{ firstSegment?.arrivalAirport }}
        </div>
        <div class="fs-22px text-am-white" *ngIf="timeConnecting.hours > 0 || timeConnecting.minutes > 0">
          <span *ngIf="timeConnecting.hours > 0">{{ timeConnecting.hours }}h</span> {{ timeConnecting.minutes }}m
        </div>
      </div>

      <div class="srIrops-textTwoConnecting" *ngIf="lineRoute == 4">
          <div class="fs-22px text-am-white" *ngFor="let scale of scales; let i = index;">
              <span [ngClass]="{ 'fs-22px text-am-white': scale.isAffected }">
                  {{ scale.iataDeparture }}
                  <span class="srIrops-comma text-am-white" *ngIf="i < (scales.length - 1)">
                  , 
                  </span>
              </span>
          </div>
      </div>

      <div class="srIrops-lineTwo" [ngClass]="{ 'srIrops-isNotAffected': !isAfectedLastSeg }">
      </div>
      <div class="srIrops-pointDestination"
        [ngClass]="{ 'srIrops-isNotAffected': !isAfectedLastSeg }">
      </div>
    </div>
    <div class="srIrops-destination">
      <span class="srIrops-destinationDate text-am-white fs-24px fw-regular lh-34px">
        {{ dateArrival | localizedDate:'dd MMM' | lowercase }}
      </span>
      <div class="srIrops-destinationHour text-am-white fs-32px fw-medium-x lh-42px"
        [ngClass]="{ 'srIrops-textNotAffected': !isAfectedLastSeg }">
        <span>
          {{ timeItinerary.arrivalTime | validHourUndefined }}
        </span>
      </div>
      <div class="srIrops-destinationDeparture text-am-white fs-24px fw-regular lh-34px">
        <span>
          {{ lastSegment?.arrivalAirport }}
        </span>
      </div>
    </div>
  </div>
</div>
<!--<banner-no-elegible></banner-no-elegible>-->